import React, { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CalendarWrapper from "../../CalendarWrapper";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import 'moment/locale/sq'  
import DisabledInput from "../../DisabledInput";
import DatePicker from "react-datepicker";


const PayrollData = ({validationErrors,payroll,setPayroll,handleChange,disabled,hasActions,isEdit }) => {
    const { t } = useTranslation("translations");
    const periodRef = useRef();

    const handlePeriodChange =(date)=>{
      const description = `Pagese paga ${moment(date).locale("sq").format("MMMM YYYY")}`

      setPayroll((payroll)=>{
        const salaryRecords = payroll.salaryRecords.map(record=>({
        ...record,
        description:description
      }))
        return {
        ...payroll,
        period: date ? moment(date).format("MM/yyyy") : "",
        salaryRecords:disabled?payroll.salaryRecords:salaryRecords,
        description:disabled?payroll.description:description
      }})
    }
    

  const datesDisabled = payroll?.workflowStatus?.name != null ? payroll.workflowStatus.name !== "DRAFT" : false;
  

    return (
      <div>
        <div className="d-flex justify-content-between header border-bottom" style={{width:"100%"}}>
            <div>
              <label className="field-label ml-1">{t("payRoll.payrollData")}</label>
            </div>
        </div>
        <div className="row mx-1 mx-md-auto pt-2">
          <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="period">{t("payRoll.period")}</label>
              <DisabledInput disabled={disabled} value={payroll?.period}>
                <CalendarWrapper
                  id="periodDate"
                  ref={periodRef}
                  selected={payroll.period ? moment(payroll.period, "MM/yyyy").toDate() : null}
                  placeholderText={t("queue.selectDate")}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  showFullMonthYearPicker
                  onChange={(date) =>handlePeriodChange(date)}
                  customInput={
                    <div className={`form-control d-flex justify-content-center align-items-center ${validationErrors.period ? "is-invalid" : "" } ${disabled?"disabled":""}`} style={{ cursor: "pointer",height:30 }}>
                      <FontAwesomeIcon icon={faCalendar} style={{fontSize:14}}/>
                      <div className="ml-1">
                        {payroll?.period}
                      </div>
                    </div>
                  }
                />
              </DisabledInput>
          </div>
          <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="recordDate">{t("payRoll.payrollOrderDate")}</label>
            <DatePicker
              selected={payroll?.issueDateTime}
              onChange={(date)=>handleChange(null,"issueDateTime",date)}
              dateFormat="dd/MM/yyyy"
              disabled={datesDisabled}
              customInput={
                <input
                  className={`form-control form-control-sm ${validationErrors.issueDateTime ? "is-invalid" : ""
                    }`}
                />
              }
            />
          </div>
          <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="requestId">{t("payRoll.requestId")}</label>
              <input
                type="text"
                name="requestId"
                className="form-control form-control-sm"
                value={payroll?.requestId ?? ""}
                onChange={handleChange}
                disabled={!isEdit || disabled}
              />
          </div>
          <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="requestedExecutionDate">{t("payRoll.requestedExecutionDate")}</label>
            <DatePicker
              selected={payroll?.requestedExecutionDate}
              onChange={(date)=>handleChange(null,"requestedExecutionDate",date)}
              dateFormat="dd/MM/yyyy"
              disabled={datesDisabled}
              customInput={
                <input
                  className={`form-control form-control-sm ${validationErrors.requestedExecutionDate ? "is-invalid" : ""
                    }`}
                />
              }
            />
          </div>
          <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="approvalDate">{t("payRoll.approvalDate")}</label>
              <input
                type="text"
                name="approvalDate"
                id="approvalDate"
                className="form-control form-control-sm"
                value={payroll?.approvalDate ? moment(payroll?.approvalDate).format("DD/MM/YYYY") : ""}
                onChange={handleChange}
                disabled
              />
          </div>
        </div>
      </div>

    );
};

export default PayrollData;